import { render, staticRenderFns } from "./DashboardModule.vue?vue&type=template&id=9bd544a6"
import script from "./DashboardModule.vue?vue&type=script&lang=js"
export * from "./DashboardModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports